import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ApiResponse } from 'src/app/shareModule/models/common.model';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';
import { LocalServiceService } from 'src/app/shareModule/services/local-service.service';
import { environment } from 'src/environments/environment';
import { Location } from '@angular/common';
import { MarketplacePageComponent } from '../../marketplace/marketplace.component';
import { CustomerService } from 'src/app/shareModule/services/customer.service';
import { SeoService } from 'src/app/shareModule/services/seo.service';
import { SharedService } from 'src/app/shareModule/services/shared.service';
import { GoogleMapsService } from 'src/app/google-maps.service';
import { AppState } from 'src/app/shareModule/states/app.state';
import { select, Store } from '@ngrx/store';
import { loadAllCommunityProducts, selectAllCommunityProducts } from 'src/app/shareModule/states/community-product';
import { Subscription } from 'rxjs';
import { RoleService } from 'src/app/shareModule/services/roles/role.service';
import { CompareProductListComponent } from '../../compare-product-list/compare-product-list.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ["../../marketplace/marketplace.component.scss", './search.component.scss']
})
export class SearchComponent implements OnInit, OnDestroy {

  @ViewChild('marketplace') marketplacePage: MarketplacePageComponent;

  public subCategory: any = {
    relationCategories: []
  }
  public subCategoryList: Array<any> = [];
  public totalMemberShopProductList: Array<any> = [];
  public currentCategorySlug: string = '';
  public currentCategoryName: string = '';
  public currentCategoryBG: string = ''
  public imgUrl = environment.ImageUrl;
  public isLogin: boolean = false;
  public isLoading = false;

  public get isOnMobile() {
    if (this.sharedService.isBrowser()) {
      return window.innerWidth <= 980
    }
    return true;

  }

  private routeSubscription: Subscription | null = null;

  constructor(
    private _location: Location,
    private route: ActivatedRoute,
    private local: LocalServiceService,
    private auth: AuthServiceService,
    private customerService: CustomerService,
    private toastr: ToastrService,
    private seoService: SeoService,
    private sharedService: SharedService,
    private googleMapsService: GoogleMapsService,
    //private store: Store<AppState>,
    private roleService: RoleService,
    private modalService: NgbModal
  ) {
    this.local.getUserDetailsObserver().subscribe((user) => {
      this.isLogin = (user?.id) ? true : false;
    });


  }
  ngOnDestroy(): void {
    this.routeSubscription?.unsubscribe();
    this._fetchProductsSubscription?.unsubscribe();
    this.googleMapsService.removeCurrentMap();
  }

  public topImageLoad(event) {
    event.target.classList.remove('d-none') //show the img if there are no errors only
  }

  public productSelectedChanged(product, isSelected) {
    let indexOfProduct = this.productsToCompare.indexOf(product)
    if (isSelected) {
      if (indexOfProduct == -1) {
        this.productsToCompare.push(product);
      }
    }
    else {
      if (indexOfProduct !== -1) {
        this.productsToCompare.splice(indexOfProduct, 1)
      }
    }
  }



  public lastPage;
  private _fetchProductsSubscription: Subscription | null = null;
  public productsToCompare = []
  ngOnInit(): void {
    // this._fetchProductsSubscription?.unsubscribe();

    // this._fetchProductsSubscription = this.store
    //   .pipe(select(selectAllCommunityProducts))
    //   .subscribe((response: any) => {


    //     if (response?.data) {
    //       this.totalMemberShopProductList = [
    //         ...this.totalMemberShopProductList,
    //         ...structuredClone(response?.data),

    //       ]
    //       this.productsToCompare = this.totalMemberShopProductList?.slice(0, 5)

    //       this.lastPage = response?.lastPage;
    //     }

    //     if (this.subCategory) {
    //       const images = new Map();
    //       const subCatKey = this.subCategory?.id
    //       images.set(subCatKey, this.subCategory?.image)

    //       //this.googleMapsService.setCategoryIconMap(images);
    //       // console.log(images, this.subCategory)

    //       //no zoom when marker is clicked
    //       this.googleMapsService.initMap(this.totalMemberShopProductList, 'map', false, false);

    //     } else {
    //       console.error("Subcategory not loaded!!")
    //     }
    //   });

    this.routeSubscription?.unsubscribe();

    this.routeSubscription = this.route.paramMap.subscribe(params => {
      //queryParams
      // console.log('params changed')
      this.totalMemberShopProductList = [];
      this.currentPage = 1;
      this.lastPage = -1;
      if (params.get('categoryName')) {
        this.currentCategorySlug = params.get('categoryName');
        this.currentCategoryName = ''
        this.getCategoryRelationship(params.get('categoryName'), params.get('subCategoryName') ? params.get('subCategoryName').trim() : '');
      }

      if (params.get('slug')) {
        setTimeout(() => {
          this.viewProductDetails({ id: params.get('slug').split('-')[1] });
        }, 1000);
      }
    });


  }

  /*************************code related to types/faqs *********************************/
  public typesExist = true;
  public faqsExist = true;
  public showMap = true;

  public isInitDone = false;
  public carOptions = {
    slidesPerView: 1,
    //spaceBetween: 10,
    initialSlide: 1,
    autoHeight: true
  };

  public realignSwiperIndexWhenTabsChange() {
    if (!this.typesExist) {
      this.carOptions.initialSlide = 0;
    }
    this.carOptions = { ...this.carOptions }
  }

  public get isUserAnAdmin() {
    return this.roleService?.roles?.userType.includes('ADMIN');
  }


  /************************ Comapare products *****************************************/

  public openCompareProductsModal() {
    //used to open a modal that is used to comapre the top 5 results from the search

    // this.productsToCompare.forEach(
    //   pd => {
    //     this.productBottomDiscussExperienceTabSettings.push(this.getBottomTabInfo(pd));
    //   }
    // )

    this.loadCompareProductsRatings();
    this.loadOtherImagesOfCompareProducts();
    this.productsToCompare.forEach(prod => prod.enableMemberShop = true)

    //console.log(this.productsToCompare)
    const ref = this.modalService.open(CompareProductListComponent, { size: 'lg', windowClass: 'transparent-window', modalDialogClass: 'glass-bg', centered: true });
    ref.componentInstance.productsToCompare = this.productsToCompare;
    ref.componentInstance.productBottomDiscussExperienceTabSettings = this.productBottomDiscussExperienceTabSettings
  }

  private loadCompareProductsRatings() {
    ////console.log('LOADING ratings') //DELETE LATTER
    for (const pd of this.productsToCompare) {
      this.loadRatingOn(pd)
    }
  }

  private loadMoreBadgesOfProduct(list) {
    if (list.otherRatingBadges?.length) {
      return;
    }
    list.otherRatingBadges = [];
    if (list && 'seller_info' in list) {
      try {
        let sellerInfo = list['seller_info'];
        if (typeof sellerInfo == 'string') {
          sellerInfo = JSON.parse(list['seller_info']);
        }

        if (sellerInfo) {
          if ('superDealRating' in sellerInfo && (sellerInfo.superDealRating || sellerInfo.superDealText)) {
            list.otherRatingBadges.push({
              icon: 'super_deal_1.png',
              name: 'Super Deal',
              rating: sellerInfo.superDealRating,
              text: sellerInfo.superDealText,
            })
          }

          if ('bestPriceRating' in sellerInfo && (sellerInfo.bestPriceRating || sellerInfo.bestPriceText)) {
            list.otherRatingBadges.push({
              icon: 'best_price_1.png',
              name: 'Best Price',
              rating: sellerInfo.bestPriceRating,
              text: sellerInfo.bestPriceText
            })
          }

          if ('highQualityRating' in sellerInfo && (sellerInfo.highQualityRating || sellerInfo.highQualityText)) {
            list.otherRatingBadges.push({
              icon: 'high_quality_1.png',
              name: 'Hight Quality',
              rating: sellerInfo.highQualityRating,
              text: sellerInfo.highQualityText
            })
          }
        }
      } catch (e) {
        console.warn(e)
      }
    }
  }
  productBottomDiscussExperienceTabSettings = [

  ]



  private loadRatingOn(pd) {
    this.loadMoreBadgesOfProduct(pd);
    let ratings = []

    if (pd && pd['seller_info']) {


      let sellerInfo = pd['seller_info'];
      ////console.log('seller_info is in productData', sellerInfo) //DELETE LATTER
      ////console.log('seller info is ', sellerInfo)

      if (sellerInfo && typeof sellerInfo === 'string') {
        sellerInfo = JSON.parse(sellerInfo)
      } else {
        pd.ratings = []
      }
      if ('googleReviewRating' in sellerInfo) {
        ratings.push({
          icon: 'ggle.png',
          name: 'Google Reviews',
          ratingUrl: sellerInfo.googleReviewUrl,
          rating: sellerInfo.googleReviewRating,
          counts: sellerInfo.googleReviewCount
        })
      }
      if ('fbReviewRating' in sellerInfo) {
        ratings.push({
          icon: 'facebook.png',
          name: 'Facebook Reviews',
          ratingUrl: sellerInfo.fbReviewUrl,
          rating: sellerInfo.fbReviewRating,
          counts: sellerInfo.fbReviewCount
        })
      }

      if ('carousellReviewRating' in sellerInfo) {
        ratings.push({
          icon: 'carousell.png',
          name: 'Carousel Reviews',
          ratingUrl: sellerInfo.carousellReviewUrl,
          rating: sellerInfo.carousellReviewRating,
          counts: sellerInfo.carousellReviewCount
        })
      }




    }
    ratings = structuredClone(ratings)
    //console.log('ratings are ', ratings)
    pd.ratings = ratings
  }



  private getImageByAccessor(images, accessor) {
    const imageObj = images?.find((o) => o.imageAccessor === accessor);
    return imageObj ? imageObj.image : "";
  };

  private loadOtherImagesOfProduct(productData) {
    productData["foodSpecs"] = productData?.memberShopProductsVariations || [];
    productData["food_image_1"] = this.getImageByAccessor(productData.memberShopProductsImages, "image1");
    productData["food_image_active"] = productData["food_image_1"];
    productData["food_image_2"] = this.getImageByAccessor(productData.memberShopProductsImages, "image2");
    productData["food_image_3"] = this.getImageByAccessor(productData.memberShopProductsImages, "image3");
    productData["food_image_4"] = this.getImageByAccessor(productData.memberShopProductsImages, "image4");


  }
  private loadOtherImagesOfCompareProducts() {
    for (const prod of this.productsToCompare) {
      this.loadOtherImagesOfProduct(prod)
    }


  }
  /********************************************************************************** */

  /********************************************************************************** */

  public currentPage = 1;
  //region: Array<any>, filter: any
  public getProductList() {
    this.isLoading = true;
    let payload = {
      basedProduct: 'all',
      page: this.currentPage++,
      categoryId: this.currentCategoryId as any,
      limit: 12
    };


    // this.store.dispatch(
    //   loadAllCommunityProducts({

    //     basedProduct: 'all',
    //     page: this.currentPage++,
    //     categoryId: this.currentCategoryId as any,
    //     limit: 12
    //   })
    // );
    this.customerService.getMemberShopProductList(payload).subscribe((response: ApiResponse) => {
      //console.log({response})
      if (response?.body) {
        this.totalMemberShopProductList = [
          ...this.totalMemberShopProductList,
          ...structuredClone(response?.body.data),

        ]

        this.productsToCompare = this.totalMemberShopProductList?.slice(0, 5)

        this.lastPage = response?.body.lastPage;
      }
      this.isLoading = false;

      if (this.subCategory) {
        const images = new Map();
        const subCatKey = this.subCategory?.id
        images.set(subCatKey, this.subCategory?.image)

        //this.googleMapsService.setCategoryIconMap(images);
        // console.log(images, this.subCategory)

        //no zoom when marker is clicked
        this.googleMapsService.initMap(this.totalMemberShopProductList, 'map', false, false);

      } else {
        console.error("Category not loaded")
      }

    });
  }

  public bottomText = '';
  public getCategoryRelationship(categoryName, subCategoryName) {
    this.auth.getCategoryRelationshipByName({ slug: categoryName.trim().toLowerCase() }).subscribe((resp: ApiResponse) => {
      this.subCategory = resp?.body
      this.isInitDone = true;
      this.currentCategoryName = this.subCategory.name
      this.currentCategoryBG = this.subCategory.bannerImage

      // if(this.sharedService.isBrowser() && this.subCategory?.codeSchema){
      //   try{
      //       //making sure error here doesn't crash the view
      //       eval(this.subCategory?.codeSchema)
      //   }catch(e){
      //     console.error(e);

      //   }
      // }
      this.bottomText = this.subCategory?.bottomText;

      if (this.subCategory?.title) {
        //console.log('setting title to', this.subCategory?.title)
        this.seoService.update({
          title: this.subCategory.title,
          description: this.bottomText,
        });
      }
      this.subCategoryList = resp?.body?.subCategory || [];
      if (this.subCategoryList.length > 0 && subCategoryName) {
        this.currentCategoryId = this.subCategoryList.find((i) => i.categoryName.toLowerCase() == subCategoryName.toLowerCase())?.categorieChildId;
        this.getProductList();
      } else if (this.subCategoryList.length > 0) {
        this.currentCategoryId = this.subCategoryList.map(i => i.categorieChildId)
        this.getProductList();
      } else {
        this.currentCategoryId = [resp?.body?.id]
        this.getProductList();
      }


      if (this.sharedService.isBrowser()) {
        this.seoService.removeSchema()
        this.seoService.initCategorySchema(this.subCategory)
      }


    })
  }

  private currentCategoryId;
  public goBack() {
    this._location.back();
  }


  public viewProductDetails(product): void {
    this.marketplacePage.enableMemberShop = true;
    this.marketplacePage.viewProduct(product);
  }

}
